import React, { useState } from "react";
import { Box, Grid, Typography, Button, MenuItem } from "@mui/material";
import { AiOutlineMinus } from "react-icons/ai";
import AddIcon from "@mui/icons-material/Add";
import styles from "./HomeNew.module.css";
import home_images from "../../assets/images/AI Home.jpg";
const skilltype = [
  {
    value: "pst",
    label: "PST",
  },
  {
    value: "cst",
    label: "CST",
  },
  {
    value: "mst",
    label: "MST",
  },
];

const AboutUs = () => {
  const [skills, setSkills] = useState([
    { skill: "", experience: "", zone: "", industry: "" },
  ]);

  const handleAddSkill = () => {
    setSkills([
      ...skills,
      { skill: "", experience: "", zone: "", industry: "" },
    ]);
  };

  const handleRemoveSkill = (index) => {
    const newSkills = skills.filter((_, i) => i !== index);
    setSkills(newSkills);
  };

  const handleChange = (index, field, value) => {
    const newSkills = [...skills];
    newSkills[index][field] = value;
    setSkills(newSkills);
  };

  return (
    <Box className={styles.employer_details}>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Box>
          <img
            src={home_images}
            alt=""
            width="100%"
            // height="120px"
            style={{ marginTop: "20px" }}
          />
        </Box>
      </Grid>
      {/* <Box className={styles.employer_details}> */}
      <Grid
        item
        xs={12}
        sm={12}
        md={12}
        lg={12}
        style={{ padding: "10px 10px 55px 20px", backgroundColor: "#f2f6f7" }}
      >
        <Box>
          <Typography sx={{ fontSize: "20px !important" }}>
            <b>Welcome to Povital</b>
          </Typography>
          <Typography sx={{ fontSize: "16px !important", marginTop: "10px" }}>
            At Povita, we are dedicated to redefining the recruitment process
            for businesses of all sizes. Our cutting-edge Applicant Tracking
            System (ATS) is designed to streamline your recruitment workflows,
            enhance Candidate, employees and employer’s day to day experience,
            and empower to hiring with the tools needed to attract and retain
            top talent.
          </Typography>
        </Box>
      </Grid>
    </Box>
  );
};

export default AboutUs;
